import { PaginationLoadMore, PaginationType } from '@edikk-edikk/pagination';
import { FC, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import { useApi } from '#hooks/use-api';
import { useAdvertListContext } from '#advertList/hooks/use-advert-list-context';
import buttonLoadMoreCss from '#srcCssModules/button-load-more.module.scss';

type PropsType = {
  pagination: PaginationType;
  serviceId?: number|null;
};

const LoadMore: FC<PropsType> = ({
  pagination,
  serviceId,
}) => {
  const {
    categoryId,
    cityId,
    areaId,
  } = useAdvertListContext();
  const api = useApi();
  const [loadMore, { isFetching }] = api.getApiAdvertListByService().useLazyLoadMoreQuery();

  const renderLoadMoreText = useCallback((countInNextPage: number) => (
    <FormattedMessage
      defaultMessage="Load more {countInNextPage, plural, =1 {# model} other {# models}}"
      values={{ countInNextPage }}
    />
  ), []);

  const handlerLoadMore = (page: number) => {
    loadMore({
      categoryId,
      cityId,
      areaId,
      page,
      serviceId,
    });
  };

  return (
    <PaginationLoadMore
      page={pagination.page}
      pageCount={pagination.pageCount}
      pageSize={pagination.pageSize}
      totalCount={pagination.totalCount}
      isFetching={isFetching}
      loadMore={handlerLoadMore}
      className={classNames('btn btn-white', buttonLoadMoreCss.buttonLoadMore)}
      loaderColor="#000"
      loadMoreText={renderLoadMoreText}
    />
  );
};

export { LoadMore };
